import { useTranslation } from 'react-i18next';
import FeatureTile, {
    FeatureTileComponent,
} from '../../FeatureTile/FeatureTile';
import { AirplaneTakeOffRegular } from '@fluentui/react-icons';
import { useSelector } from '../../../../store/hooks';
import { FeatureServiceKey } from '../../../../store/features/healthDashboard/healthDashboardSlice';
import { useFeatureStatus, useIssueFeatureItems } from '../../healthUtils';

const relatedServices: readonly FeatureServiceKey[] = [
    'gatwickApi',
    'heathrowApi',
    'crewRoster',
    'functionApp',
    'grpcServer',
] as const;

const DepartureBoardTile: FeatureTileComponent = ({ className }) => {
    const { t } = useTranslation();

    const { healthInfo } = useSelector((x) => x.healthDashboard);

    const info = healthInfo?.flightProvisioning;

    const status = useFeatureStatus(
        info && info.errorCount > 0,
        info?.lastSuccessOnUtc,
        info?.lastErrorOnUtc
    );

    const items = useIssueFeatureItems(info?.errorCount, status);

    return (
        <FeatureTile
            title={t('Health_DepartureBoard_Title')}
            icon={<AirplaneTakeOffRegular />}
            status={status}
            items={items}
            relatedServices={relatedServices}
            className={className}
        />
    );
};

export default DepartureBoardTile;
